import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Button } from './ui/button';
import { TESTIMONIALS } from '../mock/mock';

const Testimonials = () => {
  return (
    <div>
      <div className="mb-5">
        <h3 className="text-2xl lg:text-[26px] font-extrabold text-slate-900">What Our <span className="gradient-text">Merchants Say</span></h3>
        <div className="h-1 w-16 rounded-full gradient-primary mt-2" />
      </div>

      <div className="space-y-3">
        {TESTIMONIALS.slice(0, 2).map((t, i) => (
          <div key={i} className="relative bg-white rounded-2xl border border-purple-100 p-4 soft-shadow hover-lift">
            <Quote className="absolute -top-2 right-3 w-6 h-6 text-purple-200" />
            <div className="flex items-center gap-3">
              <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-xl object-cover" />
              <div>
                <div className="font-extrabold text-slate-900 text-sm">{t.name}</div>
                <div className="text-[11px] text-slate-500">{t.location}</div>
                <div className="flex gap-0.5 mt-0.5">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-3 h-3 text-amber-400 fill-amber-400" />
                  ))}
                </div>
              </div>
            </div>
            <p className="mt-2.5 text-[12.5px] text-slate-700 leading-relaxed">“{t.text}”</p>
          </div>
        ))}
      </div>

      <Button variant="outline" className="mt-4 w-full rounded-xl border-2 border-purple-200 text-[#5F259F] font-semibold hover:bg-purple-50">
        View More Reviews →
      </Button>
    </div>
  );
};

export default Testimonials;
